import React from "react";

const Public = ({ children }) => children;

export default Public;
